import {
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    ListItemSecondaryAction,
    Avatar,
    Typography,
    IconButton,
    Select,
    MenuItem,
    Checkbox,
    FormControlLabel,
    Stack,
    Chip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import React, {useState} from "react";
import {useUpdateMemberAccess} from '../../data/members';
import {BoardMember} from '../../types/task';

type EditableMemberRole = 'editor' | 'viewer' | 'assignee';

const EDITABLE_ROLES: EditableMemberRole[] = ['viewer', 'assignee', 'editor'];

export function MembersList({ members, boardId, canManageMembers }: { members: BoardMember[], boardId: string, canManageMembers: boolean }) {
    const [editingMemberId, setEditingMemberId] = useState<string | null>(null);

    const {mutate: updateMember} = useUpdateMemberAccess(boardId);

    if (members.length === 0) {
        return <Typography variant="body2" color="text.secondary">No other members yet.</Typography>;
    }

    return (
        <List disablePadding>
            {members.map((member) => (
                <ListItem
                    key={member.id}
                    divider
                    sx={{px: 0, pr: canManageMembers ? 6 : 0, '&:last-of-type': {borderBottom: 0}}}
                >
                    <ListItemAvatar>
                        <Avatar />

                    </ListItemAvatar>

                    <ListItemText
                        primary={member.firstName ? `${member.firstName} ${member.lastName}`: (member.email ?? 'Unknown')}
                        secondary={
                            <>
                                {member.firstName && (
                                    <>
                                        <Typography component="span" variant="body2">
                                            {member.email}
                                        </Typography>
                                        <br />
                                    </>
                                )}
                                {editingMemberId === member.id ? (
                                    <Stack direction="row" spacing={1} alignItems="center" component="span">
                                        <Select
                                            size="small"
                                            value={member.role}
                                            autoFocus
                                            onChange={(e) => updateMember({member, role: e.target.value as EditableMemberRole, kiosk: !!member.kiosk})}
                                        >
                                            {EDITABLE_ROLES.map((role) => (
                                                <MenuItem key={role} value={role}>{role}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    checked={!!member.kiosk}
                                                    onChange={(e) => updateMember({member, role: member.role as EditableMemberRole, kiosk: e.target.checked})}
                                                />
                                            }
                                            label="Kiosk"
                                        />
                                    </Stack>
                                ) : (
                                    <Chip
                                        component="span"
                                        size="small"
                                        variant="outlined"
                                        label={`${member.role}${member.kiosk ? ' · kiosk' : ''}`}
                                        sx={{mt: 0.5}}
                                    />
                                )}
                            </>
                    }
                    />

                    {canManageMembers && (
                        <ListItemSecondaryAction>
                            <IconButton
                                size="small"
                                onClick={() => setEditingMemberId(editingMemberId === member.id ? null : member.id)}
                            >
                                {editingMemberId === member.id ? <CloseIcon fontSize="small" /> : <EditIcon fontSize="small" />}
                            </IconButton>
                        </ListItemSecondaryAction>
                    )}
                </ListItem>
            ))}
        </List>
    );
}